import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { Alert, AlertClose, Button, Card, Input, Link, Type } from '@uswitch/spark';
import { HiOutlineMail } from '@uswitch/spark-icons/hi';
import { UswErrorOutline, UswCheckCircleFill } from '@uswitch/spark-icons/usw';
import { RichText } from '@uswitch/ev-core/react';
import { useBrand, useDataSelector, useMeta } from '@uswitch/ev-utils/context/selectors';
import { toKebabCase, toSnakeCase } from '@uswitch/ev-utils/string';
import { useConsent } from '../../../utils/consent-api';
import { useSticky } from '../../helpers/use-sticky';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var formStatuses = {
  success: 'success',
  error: 'error',
  initial: 'initial'
};

var getPageSlug = function getPageSlug(pagePath) {
  return toSnakeCase(pagePath) || 'homepage';
};

export var EmailCaptureForm = function EmailCaptureForm(_ref) {
  var _ref$submitButtonText = _ref.submitButtonText,
      submitButtonText = _ref$submitButtonText === void 0 ? 'Subscribe' : _ref$submitButtonText,
      successMessage = _ref.successMessage,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky,
      copy = _ref.copy,
      name = _ref.name,
      variant = _ref.variant,
      _ref$uconsentSource = _ref.uconsentSource,
      uconsentSource = _ref$uconsentSource === void 0 ? 'uswitch.marketing-fpe-savings-pre-results' : _ref$uconsentSource,
      _ref$hidePrivacy = _ref.hidePrivacy,
      hidePrivacy = _ref$hidePrivacy === void 0 ? false : _ref$hidePrivacy;

  var _useState = useState(formStatuses.initial),
      _useState2 = _slicedToArray(_useState, 2),
      formStatus = _useState2[0],
      setFormStatus = _useState2[1];

  var brand = useBrand();
  var pagePath = useDataSelector(['location', 'pathname'], '');
  var privacyPolicyPath = useMeta('privacyPolicyPath');
  var defaultSuccessMessage = useMeta(['leadCaptureForm', 'emailCapture', 'successMessage'], 'Thank you for subscribing');
  var consentApiName = useMeta('consentApiName');
  var consentMethod = 'captureImplicitOptIn';
  var consentArgs = {
    consent: uconsentSource,
    onSuccess: function onSuccess() {
      return setFormStatus(formStatuses.success);
    },
    onError: function onError() {
      return setFormStatus(formStatuses.error);
    }
  };
  useConsent({
    consentApiName: consentApiName,
    method: consentMethod
  }, consentArgs);

  var _useSticky = useSticky(isSticky),
      stickyContainerRef = _useSticky.stickyContainerRef,
      stickyClassName = _useSticky.stickyClassName,
      stickyStyles = _useSticky.stickyStyles;

  return Boolean(consentApiName) ? _jsx("div", {
    ref: stickyContainerRef,
    children: _jsxs(Card, {
      className: stickyClassName,
      sx: {
        background: 'white',
        p: 'md',
        mt: 'sm',
        mb: 'md',
        '&.sticky-fixed': stickyStyles,
        // TODO: Use spark Type components for RichTexts so this styling override can be removed
        'h1,h2,h3,h4,h5,h6': {
          color: 'grey-100',
          mt: 0,
          mb: 'sm'
        }
      },
      children: [_jsx(RichText, {
        content: copy === null || copy === void 0 ? void 0 : copy.content
      }), formStatus === formStatuses.error ? _jsx(Alert, {
        icon: _jsx(UswErrorOutline, {
          size: 24
        }),
        title: "Error",
        variant: "error",
        closeButton: _jsx(AlertClose, {
          onClick: function onClick() {
            return setFormStatus(formStatuses.initial);
          }
        }),
        children: "Something went wrong"
      }) : null, _jsxs("form", {
        name: 'uconsent-form',
        className: "uconsent",
        "data-consent-source": "".concat(brand, ".").concat(getPageSlug(pagePath), ".lead-capture-form.").concat(toKebabCase(variant), ".").concat(toKebabCase(name)),
        children: [_jsxs("div", {
          sx: {
            mt: '-sm',
            py: 'md',
            position: 'relative'
          },
          children: [_jsxs("div", {
            sx: {
              display: 'flex',
              flexDirection: ['column', 'row'],
              opacity: formStatus === 'success' ? 0 : 100
            },
            children: [_jsx("div", {
              sx: {
                flex: 1
              },
              children: _jsx(Input, {
                sx: {
                  input: {
                    boxSizing: 'border-box'
                  }
                },
                leftIcon: _jsx(HiOutlineMail, {
                  size: "2em",
                  sx: {
                    stroke: 'grey-60'
                  }
                }),
                placeholder: "Your email",
                type: "email",
                required: true
              })
            }), _jsx(Button, {
              type: "submit",
              sx: {
                flex: 0,
                mt: ['sm', 0],
                ml: [0, 'sm'],
                px: 'xl'
              },
              children: submitButtonText
            })]
          }), formStatus === formStatuses.success ? _jsxs("div", {
            sx: {
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)'
            },
            children: [_jsx(UswCheckCircleFill, {
              size: "2.5em",
              sx: {
                fill: 'success',
                verticalAlign: 'middle',
                mr: 'xxs'
              }
            }), _jsx(Type.Body1, {
              children: successMessage || defaultSuccessMessage
            })]
          }) : null]
        }), _jsxs(Type.Body2, {
          children: [_jsx("span", {
            className: "uconsent-text"
          }), ' ', Boolean(privacyPolicyPath) && !hidePrivacy ? _jsx(Link, {
            newTab: true,
            to: privacyPolicyPath,
            text: "Privacy Policy",
            sx: {
              borderBottom: '1px solid black'
            }
          }) : null]
        })]
      })]
    })
  }) : null;
};
export default EmailCaptureForm;
//# sourceMappingURL=email-capture-form.js.map